var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showAdvertising)?_c('div',{attrs:{"id":"advertising"}},[_c('div',{staticClass:"white-wrapper advertising"},[_c('spinner'),_c('span',{staticClass:"advertising__tnx"},[_vm._v("Спасибо, что пользуетесь нашим приложением")]),_c('span',{staticClass:"advertising__tnx-heart"},[_vm._v("❤️")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }